import { Component, OnInit } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { CmsService } from 'src/app/services/api/cms.service';
  
@Component({
  selector: 'app-guidelines',
  templateUrl: './guidelines.component.html',
  styleUrls: ['./guidelines.component.scss']
})
export class GuidelinesComponent implements OnInit {
  shipping_information: any;
  shipping_method: any;
  order_summary: any;
  onClose: any;

  constructor(
    public lang: LangService,
    public cms: CmsService,
  ) { }

  ngOnInit(
    
  ) {

    this.cms.getBlockv2(7, false, false).then(res => {
      this.shipping_information = res.content;
    });

    this.cms.getBlockv2(8, false, false).then(res => {
      this.shipping_method = res.content;
    });

    this.cms.getBlockv2(9, false, false).then(res => {
      this.order_summary = res.content;
    });

  }

  close(){
    this.onClose();
  }

}
